import { render, staticRenderFns } from "./IsStar.vue?vue&type=template&id=8dd84d92&scoped=true"
import script from "./IsStar.vue?vue&type=script&lang=js"
export * from "./IsStar.vue?vue&type=script&lang=js"
import style0 from "./IsStar.vue?vue&type=style&index=0&id=8dd84d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd84d92",
  null
  
)

export default component.exports